import "./../../bindings/bao-number-box";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-date-time-picker";
import GenericListTab from "./../../factories/generic-list-tab";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
class ConfigurationItem150Characteristic extends GenericListTab {
    Bao = Bao;
    DialogWidth = 500;
    CustomFilter() {
        return null;
    }
    ItemCompleteCheck(item): JQueryPromise<boolean> {
        var def = $.Deferred<boolean>();
        var result = true;
        if (item.ConfigurationItemIndicatorId() == null) {
            result = false;
        }
        if (item.BillingRhythmId() == null) {
            result = false;
        }
        if (item.Value() == null) {
            result = false;
        }
        if (item.SalesGroupId() == null) {
            result = false;
        }
        if (!result) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        def.resolve(result);
        return def.promise();
    }
}
export default ConfigurationItem150Characteristic;